import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { Flex } from "@similarweb/ui-components/foundations";

export const ErrorBannerButton = styled.button`
    display: flex;
    box-sizing: border-box;
    width: 100%;
    align-items: center;
    gap: 8px;
    padding: 8px 11px;
    margin: 0;
    border: none;
    border-radius: 4px;
    background-color: ${colorsPalettes.red[100]};
    cursor: pointer;
    text-align: left;
    font: inherit;
    color: inherit;

    &:focus-visible {
        outline: 2px solid ${colorsPalettes.red[400]};
        outline-offset: 2px;
    }
`;

export const ErrorIconWrap = styled(Flex)`
    flex-shrink: 0;
    width: 16px;
    height: 16px;
    align-items: center;
    justify-content: center;

    && svg {
        display: block;
    }
`;

export const ErrorContent = styled(Flex)`
    flex: 1;
    min-width: 0;
    flex-direction: column;
    align-items: flex-start;
    gap: 2px;
    overflow: hidden;
`;
